import React, { useEffect, useState, useContext } from "react";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import { Table } from "react-bootstrap";
import { Documents } from ".";
import { useParams } from "react-router-dom";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
interface NotStarted {
  status: string;
  departureHour: string;
  route: string;
  routeId: number;
}

export const TableList = ({ data }: Documents) => {
  const { getSizesComponent, setFontSize, componentProperty } =
    useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(300);
  const [widthChart, setWidthChart] = useState(300);
  const [total, setTotal] = useState<number>(0);
  const { mode } = useParams();

  useEffect(() => {
    setTotal(data.count);
    const sizes = getSizesComponent({
      id: "chart-details-not-started-collects-documents",
    });
    if (sizes.width < 345) {
      setFontSize({
        id: "chart-details-not-started-collects-documents",
        width: sizes.width,
      });
    }
    if (sizes.height > data.collects.length * 140) {
      setHeightChart(sizes.height - 80);
    } else {
      setHeightChart(data.collects.length * 10);
    }
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, [data]);

  function convertFormatDate(elem: string) {
    const date = elem.split(" ");
    date[0].split("-").reverse().join("/");
    return date[1] + " " + date[0].split("-").reverse().join("/");
  }

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Não iniciadas - detalhe: Existem ${total} rotas com coletas não iniciadas`}
        clickable={componentProperty({
          id: "chartDetailsNotStartedCollectsDocuments",
          property: "redirect",
        })}
        id="chart-details-not-started-collects-documents"
      />
      <div
        id={
          data.collects &&
          getSizesComponent({
            id: "chart-details-not-started-collects-documents",
          }).height >
            data.collects.length * 140
            ? "fixedBox"
            : "scrollBox"
        }
      >
        <div id="chart" style={{ height: heightChart }}>
          <Table
            id="tableDetailsNotStarted"
            style={{ maxHeight: heightChart, width: widthChart }}
          >
            <thead>
              <tr>
                <th>Manifesto</th>
                <th>Status</th>
                <th>Hor. Saída.</th>
              </tr>
            </thead>
            <tbody>
              {data.collects.map((elem: NotStarted, i: number) => {
                return (
                  <tr
                    id={"row_" + i}
                    onClick={() => {
                      if (
                        mode === "view" &&
                        componentProperty({
                          id: "chartDetailsNotStartedCollectsDocuments",
                          property: "redirect",
                        })
                      ) {
                        window.open(
                          `${process.env.REACT_APP_COMPROVEI_URL}/routes/details/${elem.routeId}`,
                          "_blank"
                        );
                      }
                    }}
                  >
                    <td>{elem.route}</td>
                    <td
                      className={
                        elem.status === "No Horário"
                          ? "color_green"
                          : "color_orange"
                      }
                    >
                      {elem.status}
                    </td>
                    <td>{convertFormatDate(elem.departureHour)}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
